function pad(n) {
  return n < 10 ? '0' + n : '' + n;
}

function toICSDate(date) {
  return (
    date.getFullYear() +
    pad(date.getMonth() + 1) +
    pad(date.getDate()) +
    'T' +
    pad(date.getHours()) +
    pad(date.getMinutes()) +
    '00'
  );
}

function toICSDateUTC(date) {
  return (
    date.getUTCFullYear() +
    pad(date.getUTCMonth() + 1) +
    pad(date.getUTCDate()) +
    'T' +
    pad(date.getUTCHours()) +
    pad(date.getUTCMinutes()) +
    pad(date.getUTCSeconds())
  );
}

function escapeICS(text) {
  return String(text)
    .replace(/\\/g, '\\\\')
    .replace(/;/g, '\\;')
    .replace(/,/g, '\\,')
    .replace(/\n/g, '\\n');
}

class MikolitoKreatorKalendarza extends HTMLElement {
  connectedCallback() {
    this.dateInput = this.querySelector('[data-mik-start-date]');
    this.timeInput = this.querySelector('[data-mik-start-time]');
    this.statusEl = this.querySelector('[data-mik-status]');
    this.printBtn = this.querySelector('[data-mik-print]');
    this.icsBtn = this.querySelector('[data-mik-ics]');
    this.stories = Array.from(this.querySelectorAll('[data-mik-story]'));

    if (this.dateInput && !this.dateInput.value) {
      this.dateInput.value = new Date().toISOString().slice(0, 10);
    }

    this.renderQRCodes();

    if (this.printBtn) {
      this.printBtn.addEventListener('click', () => this.printPosterPdf());
    }
    if (this.icsBtn) {
      this.icsBtn.addEventListener('click', () => this.downloadICS());
    }
  }

  printPosterPdf() {
    const pdfUrl = this.dataset.posterPdfUrl;
    if (!pdfUrl) {
      window.print();
      return;
    }

    // Open the window synchronously (before any await) so the browser still
    // treats it as user-triggered and doesn't block it as a popup.
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      window.open(pdfUrl, '_blank');
      return;
    }

    fetch(pdfUrl)
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.blob();
      })
      .then((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        let printed = false;
        const triggerPrint = () => {
          if (printed) return;
          printed = true;
          try {
            printWindow.focus();
            printWindow.print();
          } catch (err) {
            // Printing couldn't be triggered automatically; the PDF is still open for the user to print manually.
          }
        };
        printWindow.addEventListener('load', triggerPrint);
        printWindow.location = blobUrl;
        setTimeout(triggerPrint, 1500);
      })
      .catch(() => {
        // Blob fetch failed (network/CORS): fall back to showing the PDF directly.
        printWindow.location = pdfUrl;
      });
  }

  renderQRCodes() {
    if (!window.QRCode) return;
    this.stories.forEach((story) => {
      const mount = story.querySelector('[data-mik-qr]');
      const url = story.dataset.url;
      if (!mount || !url) return;
      mount.innerHTML = '';
      new window.QRCode(mount, {
        text: url,
        width: 58,
        height: 58,
        colorDark: '#1E2A4D',
        colorLight: '#ffffff',
        correctLevel: window.QRCode.CorrectLevel.M,
      });
    });
  }

  downloadICS() {
    const startDateVal = this.dateInput ? this.dateInput.value : '';
    const startTimeVal = (this.timeInput && this.timeInput.value) || '19:30';

    if (!startDateVal) {
      this.setStatus('err', 'Wybierz datę Dnia 1.');
      return;
    }

    const [year, month, dayNum] = startDateVal.split('-').map(Number);
    const [hh, mm] = startTimeVal.split(':').map(Number);

    let ics = 'BEGIN:VCALENDAR\r\nVERSION:2.0\r\nPRODID:-//Mikolito//30 Wieczorow//PL\r\nCALSCALE:GREGORIAN\r\n';

    this.stories.forEach((story, i) => {
      const title = story.dataset.title;
      const url = story.dataset.url;
      const start = new Date(year, month - 1, dayNum + i, hh, mm, 0);
      const end = new Date(start.getTime() + 15 * 60000);
      const uid = 'mikolito-dzien-' + (i + 1) + '-' + start.getTime() + '@mikolito.pl';
      const summary = `Dzień ${i + 1}: ${title} 🌙`;

      ics += 'BEGIN:VEVENT\r\n';
      ics += 'UID:' + uid + '\r\n';
      ics += 'DTSTAMP:' + toICSDateUTC(new Date()) + 'Z\r\n';
      ics += 'DTSTART:' + toICSDate(start) + '\r\n';
      ics += 'DTEND:' + toICSDate(end) + '\r\n';
      ics += 'SUMMARY:' + escapeICS(summary) + '\r\n';
      ics += 'DESCRIPTION:' + escapeICS('Czas na bajkę: ' + url) + '\r\n';
      ics += 'URL:' + url + '\r\n';
      ics += 'END:VEVENT\r\n';
    });

    ics += 'END:VCALENDAR\r\n';

    const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = '30-wieczorow-z-mikolito.ics';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);

    this.setStatus('ok', `Pobrano kalendarz z ${this.stories.length} wydarzeniami, start: ${startDateVal}.`);
  }

  setStatus(kind, text) {
    if (!this.statusEl) return;
    this.statusEl.textContent = text;
    this.statusEl.classList.toggle('mik-kreator__status--ok', kind === 'ok');
    this.statusEl.classList.toggle('mik-kreator__status--err', kind === 'err');
  }
}

customElements.define('mikolito-kreator-kalendarza', MikolitoKreatorKalendarza);
